import { useState, useEffect, useRef } from "react";
import { Constants } from "../../../constants/constants";

const useSMSTokenTimer = () => {
    const [remainingTime, setRemainingTime] = useState(0);
    const [smsRequestedCount, setSmsRequestedCount] = useState(0);
    const intervalRef = useRef(null);

    const resetTimer = () => {
        let timeElapsedCheck = Constants.SMS_CODE_ATTEMPTS_DELAY_IN_SECONDS;
        let updatedSmsRequestedCount = smsRequestedCount + 1;

        if (updatedSmsRequestedCount > Constants.MAX_CONSECUTIVE_SMS_CODE_ATTEMPTS_ALLOWED) {
            timeElapsedCheck = Constants.SMS_CODE_ATTEMPTS_LONG_DELAY_IN_SECONDS;
            updatedSmsRequestedCount = 0; // Reset the long delay counter
        }

        setRemainingTime(timeElapsedCheck);
        setSmsRequestedCount(updatedSmsRequestedCount);

        if (intervalRef.current) {
            clearInterval(intervalRef.current); // Clear any existing interval
        }

        intervalRef.current = setInterval(() => {
            setRemainingTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(intervalRef.current);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
    };

    const getRemainingTimeText = () => {
        return new Date(remainingTime * 1000).toISOString().substring(14, 19);
    };

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current); // Cleanup on unmount
            }
        };
    }, []);

    return {
        resetTimer,
        remainingTime,
        getRemainingTimeText
    };
};

export default useSMSTokenTimer;
